import React, { useState, useEffect } from 'react';
import { auth, db } from '../../firebase';
import { ref, get } from 'firebase/database';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { 
    FaUserCircle, 
    FaSignOutAlt, 
    FaChevronDown, 
    FaBell, 
    FaDesktop, 
    FaLayerGroup, 
    FaUsers, 
    FaFileAlt,
    FaRegCircle
} from 'react-icons/fa';

const AuditNavbar = () => {
    const [userData, setUserData] = useState(null);
    const [isProfileOpen, setIsProfileOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(async (user) => {
            if (user) {
                const snapshot = await get(ref(db, 'ekamwatapzp/users/' + user.uid));
                if (snapshot.exists()) {
                    setUserData(snapshot.val());
                }
            }
        });
        return () => unsubscribe();
    }, []);

    const handleLogout = async () => {
        await auth.signOut();
        localStorage.removeItem('currentUser');
        navigate('/');
    };

    const checkActive = (item) => {
        if (!item) return false;
        if (item.path && location.pathname === item.path) return true;
        if (item.children) {
            return item.children.some(child => checkActive(child));
        }
        return false;
    };

    const menuItems = [
        { 
            name: "डॅशबोर्ड", 
            path: "/audit/dashboard", 
            icon: <FaDesktop size={14} />
        },
        {
            name: "सु.बे. अभियंता",
            path: "/audit/engineers-menu",
            icon: <FaUsers size={14} />,
            children: [
                { name: "नवीन सु.बे. अभियंत्यांची यादी", path: "/audit/engineers/new" },
                { name: "जुने सु.बे. अभियंत्यांची यादी", path: "/audit/engineers/old" },
            ]
        },
        {
            name: "मजूर संस्था",
            path: "/audit/societies-menu",
            icon: <FaUsers size={14} />,
            children: [
                { name: "नवीन मजूर संस्थांची यादी", path: "/audit/societies/new" },
                { name: "जुने मजूर संस्थांची यादी", path: "/audit/societies/old" },
            ]
        },
        {
            name: "कामाची माहिती",
            path: "/audit/work-menu",
            icon: <FaLayerGroup size={14} />,
            children: [
                { name: "कामाची यादी करा", path: "/audit/work-info/list" },
                { name: "नवीन कामाची यादी", path: "/audit/work-info/new" },
                { name: "लॉटरी कम्प्लिटेड कामाची यादी", path: "/audit/work-info/lottery-completed" },
            ]
        },
        {
            name: "वर्क रिपोर्ट",
            path: "/audit/work-reports-menu",
            icon: <FaFileAlt size={14} />,
            children: [
                { name: "इंजिनिअर ट्रान्सफर", path: "/audit/work-reports/engineer-transfer" },
                { name: "मजूर संस्था ट्रान्सफर", path: "/audit/work-reports/society-transfer" },
                { name: "ओपन ट्रान्सफर", path: "/audit/work-reports/open-transfer" },
                { name: "ग्रामपंचायत", path: "/audit/work-reports/gram-panchayat" },
            ]
        },
        {
            name: "सर्व रिपोर्ट",
            path: "/audit/reports",
            icon: <FaFileAlt size={14} />,
            children: [
                { 
                    name: "सु.बे. इंटरेस्टेड वर्क लिस्ट", 
                    children: [
                        { name: "इंटरेस्टेड वर्क लिस्ट", path: "/audit/reports/engineer-interested" },
                        { name: "तारखेनुसार इंटरेस्टेड वर्क लिस्ट", path: "/audit/reports/engineer-interested-date" },
                    ]
                },
                { 
                    name: "मजूर संस्था इंटरेस्टेड वर्क लिस्ट", 
                    children: [
                        { name: "इंटरेस्टेड वर्क लिस्ट", path: "/audit/reports/society-interested" },
                        { name: "तारखेनुसार इंटरेस्टेड वर्क लिस्ट", path: "/audit/reports/society-interested-date" },
                    ]
                },
                { 
                    name: "लॉटरी यादी", 
                    children: [
                        { name: "सु.बे. लॉटरी यादी", path: "/audit/reports/lottery-list" },
                        { name: "मजूर संख्या लॉटरी यादी", path: "/audit/reports/lottery-list-society" },
                    ]
                },
                { 
                    name: "शिफारस पत्र", 
                    children: [
                        { name: "सु.बे. अभियंता", path: "/audit/reports/recommendation-letter" },
                        { name: "मजूर संख्या", path: "/audit/reports/recommendation-letter-society" },
                    ]
                },
                { 
                    name: "काम वाटप टिपणी", 
                    children: [
                        { name: "सु.बे. टिपणी यादी", path: "/audit/reports/work-allocation-note" },
                        { name: "मजूर संख्या टिपणी यादी", path: "/audit/reports/work-allocation-note-society" },
                    ]
                },
                { 
                    name: "वर्क ऑर्डर", 
                    children: [
                        { name: "सु.बे. वर्क ऑर्डर", path: "/audit/reports/work-order" },
                        { name: "मजूर संख्या वर्क ऑर्डर", path: "/audit/reports/work-order-society" },
                    ]
                },
                { 
                    name: "लॉटरी कमवाटप रिपोर्ट", 
                    children: [
                        { name: "सु.बे. रिपोर्ट", path: "/audit/reports/lottery-allocation-report" },
                        { name: "मजूर संख्या रिपोर्ट", path: "/audit/reports/lottery-allocation-report-society" },
                    ]
                },
                { 
                    name: "शिफारस करावयाची यादी", 
                    children: [
                        { name: "सु.बे. यादी", path: "/audit/reports/recommendation-list" },
                        { name: "मजूर संख्या यादी", path: "/audit/reports/recommendation-list-society" },
                    ]
                },
            ]
        },
        {
            name: "वर्कलिस्ट चलन",
            path: "/audit/challan-menu",
            icon: <FaFileAlt size={14} />,
            children: [
                { name: "इंजिनिअर चलन", path: "/audit/challan-worklist/engineer" },
                { name: "मजूर संस्था चलन", path: "/audit/challan-worklist/society" },
            ]
        }
    ];

    return (
        <header className="sticky top-0 z-[100] w-full shadow-lg">
            {/* Top Row: Branding and User Profile */}
            <div className="bg-[#f6f3ee] border-b border-gray-200/50 px-6 py-2 flex items-center justify-between h-14">
                {/* Left Section (Placeholder for balance or branding) */}
                <div className="flex-1 hidden xl:block">
                    {/* Optional: Add Logo/Text here if requested */}
                </div>

                {/* Center Title */}
                <div className="flex-[2] flex justify-center items-center">
                    <h1 className="text-[15px] md:text-xl font-extrabold text-black tracking-tight font-sans uppercase text-center whitespace-nowrap">
                        ZILLA PARISHAD SANGLI - (AUDIT DASHBOARD)
                    </h1>
                </div>

                <div className="flex-1 flex items-center justify-end gap-6">
                    <button className="text-gray-500 hover:text-emerald-600 transition-colors">
                        <FaBell size={20} />
                    </button>
                    
                    <div className="relative">
                        <div 
                            className="flex items-center gap-3 cursor-pointer group"
                            onClick={() => setIsProfileOpen(!isProfileOpen)}
                        >
                            <div className="text-right hidden sm:block">
                                <p className="text-sm font-bold text-gray-800 leading-none">{userData?.name || 'Audit Officer'}</p>
                                <p className="text-[11px] text-gray-500 font-medium mt-1 uppercase tracking-wider">{userData?.role || 'Audit'}</p>
                            </div>
                            <div className="relative">
                                <FaUserCircle size={36} className="text-gray-400 group-hover:text-emerald-600 transition-colors" />
                                <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 border-2 border-[#f6f3ee] rounded-full"></div>
                            </div>
                        </div>

                        {/* Profile Dropdown */}
                        {isProfileOpen && (
                            <>
                                <div className="fixed inset-0 z-40" onClick={() => setIsProfileOpen(false)}></div>
                                <div className="absolute right-0 mt-3 w-56 bg-white rounded-xl shadow-2xl border border-gray-100 overflow-hidden z-50 animate-in fade-in slide-in-from-top-2 duration-200">
                                    <div className="p-4 bg-gray-50/50 border-b border-gray-100">
                                        <p className="text-[10px] font-bold text-gray-400 uppercase tracking-[0.2em]">Account Management</p>
                                    </div>
                                    <div className="p-2">
                                        <button 
                                            onClick={handleLogout}
                                            className="w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-red-600 hover:bg-red-50 transition-colors"
                                        >
                                            <FaSignOutAlt size={14} />
                                            <span className="font-bold text-sm">लॉगआउट (Logout)</span>
                                        </button>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* Bottom Row: Navigation Menu */}
            <div className="bg-[#085e53] px-4 flex items-center justify-center h-12 relative shadow-md z-10">
                {menuItems.map((item, idx) => (
                    <div 
                        key={idx} 
                        className="relative h-full group"
                    >
                        <div
                            onClick={() => item.path && navigate(item.path)}
                            className={`flex items-center gap-2 px-6 h-full cursor-pointer whitespace-nowrap transition-all duration-200 text-sm font-bold ${
                                checkActive(item)
                                ? 'bg-white/20 text-white shadow-inner' 
                                : 'text-emerald-50/90 hover:bg-white/10 hover:text-white'
                            }`}
                        >
                            {item.icon}
                            <span>{item.name}</span>
                            {item.children && (
                                <FaChevronDown size={10} className="ml-1 transition-transform duration-300 group-hover:rotate-180 opacity-70" />
                            )}
                        </div>

                        {/* Dropdown Menu Container */}
                        {item.children && (
                            <div className="absolute top-[calc(100%-1px)] left-0 hidden group-hover:block z-[110] pt-0">
                                <div className="min-w-[260px] bg-white shadow-2xl border border-gray-100 overflow-visible rounded-b-lg">
                                    {item.children.map((child, childIdx) => (
                                        <div key={childIdx} className="relative group/sub">
                                            {child.children ? (
                                                <>
                                                    <div className={`flex items-center justify-between px-5 py-3 text-sm cursor-pointer border-b border-gray-50 last:border-0 transition-colors ${
                                                        checkActive(child)
                                                        ? 'bg-emerald-50 text-emerald-600 font-bold'
                                                        : 'text-gray-600 hover:bg-emerald-50 hover:text-emerald-600'
                                                    }`}>
                                                        <div className="flex items-center">
                                                            <FaRegCircle size={8} className={`mr-3 shrink-0 ${checkActive(child) ? 'opacity-100' : 'opacity-40'}`} />
                                                            <span className="whitespace-nowrap">{child.name}</span>
                                                        </div>
                                                        <FaChevronDown size={8} className={`transition-transform ${checkActive(child) ? '-rotate-90' : '-rotate-90 opacity-50'}`} />
                                                    </div>
                                                    
                                                    {/* Sub-sub-menu (Side Flyout) */}
                                                    <div className={`absolute top-0 hidden group-hover/sub:block z-[120] ${idx >= menuItems.length - 2 ? 'right-full pr-0.5' : 'left-full pl-0.5'}`}>
                                                        <div className="min-w-[220px] bg-white shadow-2xl border border-gray-100 overflow-hidden rounded-lg">
                                                            {child.children.map((subChild, subIdx) => (
                                                                <Link
                                                                    key={subIdx}
                                                                    to={subChild.path}
                                                                    className={`flex items-center px-5 py-3 text-sm transition-colors border-b border-gray-50 last:border-0 ${
                                                                        location.pathname === subChild.path 
                                                                        ? 'bg-emerald-50 text-emerald-600 font-bold' 
                                                                        : 'text-gray-500 hover:bg-emerald-50 hover:text-emerald-600'
                                                                    }`}
                                                                >
                                                                    <FaRegCircle size={6} className={`mr-3 shrink-0 ${location.pathname === subChild.path ? 'opacity-100' : 'opacity-30'}`} />
                                                                    <span className="whitespace-nowrap">{subChild.name}</span>
                                                                </Link>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </>
                                            ) : (
                                                <Link
                                                    to={child.path}
                                                    className={`flex items-center px-5 py-3 text-sm transition-colors border-b border-gray-50 last:border-0 ${
                                                        location.pathname === child.path 
                                                        ? 'bg-emerald-50 text-emerald-600 font-bold' 
                                                        : 'text-gray-600 hover:bg-emerald-50 hover:text-emerald-600'
                                                    }`}
                                                >
                                                    <FaRegCircle size={8} className={`mr-3 shrink-0 ${location.pathname === child.path ? 'opacity-100' : 'opacity-40'}`} />
                                                    <span className="whitespace-nowrap">{child.name}</span>
                                                </Link>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </header>
    );
};

export default AuditNavbar;
